const ready = (callback) => {
  if (document.readyState !== 'loading') callback()
  else document.addEventListener('DOMContentLoaded', callback)
}

ready(() => {
  const detailElements = document.querySelectorAll('.accordion details')

  setDetailsHeight('details')

  function setDetailsHeight (selector, wrapper = document) {
    const setHeight = (detail, open = false) => {
      detail.open = open
      const rect = detail.getBoundingClientRect()
      detail.style.setProperty(open ? `--expanded` : `--collapsed`, `${rect.height}px`)
    }
    const details = wrapper.querySelectorAll(selector)
    const RO = new ResizeObserver(entries => {
      return entries.forEach(entry => {
        const detail = entry.target

        if (!detail.open) {
          detail.removeAttribute('style')
          setHeight(detail)
          setHeight(detail, true)
          detail.open = false
        }
      })
    })
    details.forEach(detail => {
      RO.observe(detail)
    })
  }

  detailElements
    .forEach(details => details.addEventListener('toggle', detailsToggler))

  function detailsToggler (event) {
    if (!event.target.open) return
    let container = event.target.closest('.accordion')
    for (let details of container.querySelectorAll('details')) {
      if (details !== event.target) { details.open = false }
    }
  }
})
